import React from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import LabeledSwitch from "../../common/LabeledSwitch";

const MailArchive = ({
  enableArchive,
  selectedGroup,
  canModifyGroup,
  updateGroupMailProperties,
}) => {
  const handleEnableArchiveSwitchChange = (checked) => {
    updateGroupMailProperties({ enableArchive: checked });
  };

  return (
    <Card
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          <InboxOutlined style={{ marginRight: 8, color: "#bfbfbf" }} />
          Mail archive
        </Typography.Title>
      }
    >
      <div style={{ marginBottom: 16 }}>
        <LabeledSwitch
          checked={enableArchive}
          disabled={!canModifyGroup}
          onChange={handleEnableArchiveSwitchChange}
          label="Enable archive"
        />
      </div>
      {enableArchive && (
        <div style={{ marginLeft: 16, marginTop: 8 }}>
          <a
            href={`https://egroups-archives.web.cern.ch/group/${selectedGroup.groupIdentifier}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open archive
          </a>
        </div>
      )}
    </Card>
  );
};

MailArchive.propTypes = {
  enableArchive: PropTypes.bool,
  selectedGroup: PropTypes.object,
  canModifyGroup: PropTypes.bool,
  updateGroupMailProperties: PropTypes.func,
};

export default MailArchive;
